/**
 * KST 날짜 **표기** 헬퍼. 서버·클라 공용. (JCG-3064)
 *
 * `kst-date.ts`(ISO 연산)에서 분리했다. Intl.DateTimeFormat 생성은 로케일 협상·ICU 패턴 컴파일·
 * tz 데이터 로드가 걸리므로, 실제로 날짜를 사용자에게 보여주는 모듈만 이 파일을 import 한다.
 * 포맷터는 모두 timeZone 을 박아 실행 환경(서버 UTC / 사용자 로컬)과 무관하게 KST 로 표기한다.
 */

const KST_CALENDAR_DATE_FORMATTER = new Intl.DateTimeFormat("ko-KR", {
  year: "numeric",
  month: "long",
  day: "numeric",
  timeZone: "Asia/Seoul",
});

// 판매 시작 시각 안내(MembershipClient)에서만 쓰므로 첫 사용 때 만든다.
let kstMonthDayTimeFormatter: Intl.DateTimeFormat | undefined;

/**
 * Date 가 파싱 가능한 시각 문자열을 "2026년 7월 31일"(KST 달력 날짜)로 표시한다.
 *
 * 이용권 만료일·판매 종료일처럼 **사용자에게 보이는 날짜**의 단일 표기 지점이다.
 * 같은 `passExpiresAt`/`expiresAtISO` 를 여러 화면이 보여주므로(결제 플로우의 PassCard·
 * Premium/CompletePurchaseModal·MembershipClient, 그리고 /my 의 PassPage·PurchasesPage)
 * 포맷터가 갈리면 화면마다 표기가 어긋난다 — timeZone 을 안 박으면 26-2 만료
 * (`2026-07-31T14:59:59Z` = KST 7/31 23:59:59)가 KST 동쪽 사용자에게 8월 1일로 보인다.
 *
 * bare date(YYYY-MM-DD)도 그대로 넘기면 된다: KST 는 +9(양수·24h 미만)라 UTC 자정이
 * 곧 같은 KST 달력 날짜다. 접미사를 붙이는 분기는 결과가 동일해 두지 않는다.
 */
export function formatKstCalendarDate(dateISO: string): string {
  return KST_CALENDAR_DATE_FORMATTER.format(new Date(dateISO));
}

/** 시각 문자열을 "7월 19일 12:00"(KST)으로 표시한다. 판매 시작 시각 안내용. */
export function formatKstMonthDayTime(dateTimeISO: string): string {
  kstMonthDayTimeFormatter ??= new Intl.DateTimeFormat("ko-KR", {
    month: "long",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hourCycle: "h23",
    timeZone: "Asia/Seoul",
  });
  return kstMonthDayTimeFormatter.format(new Date(dateTimeISO));
}
